var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5189_136955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 19.9757C16.1784 19.9757 20.6466 15.5075 20.6466 9.99566C20.6466 4.48384 16.1784 0.015625 10.6666 0.015625C5.15474 0.015625 0.686523 4.48384 0.686523 9.99566C0.686523 15.5075 5.15474 19.9757 10.6666 19.9757Z",
    fill: "#DFE1E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8304 11.3263L13.0682 15.9375H16.6045L11.7981 9.09129L16.2193 4.0625H15.1718L11.3311 8.42802L8.26575 4.0625H4.72949L9.36585 10.6645L4.72949 15.9375H5.77704L9.8304 11.3263ZM7.76413 4.83398L10.7814 9.05581L11.2498 9.71365L15.1713 15.2011H13.5621L10.3629 10.7212L9.89244 10.0634L6.15487 4.83398H7.76413Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5189_136955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogoGray);
export default __webpack_public_path__ + "static/media/twitter_logo_gray.3f872546c0adb08639a85ba1b4dba604.svg";
export { ForwardRef as ReactComponent };